import { api } from 'common';
import { useState, useEffect } from 'react';
import { IUserType } from 'common/src/types';
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { mainSignUp } from 'common/src/actions/authactions';
import { CustomMaterialTable } from 'components/CustomMaterialTable';

export default function Users() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const [data, setData] = useState<IUserType[]>([]);
  const usersdata = useSelector(state => state.usersdata);
  const settings = useSelector(state => state.settingsdata.settings);
  const {
    editUser,
    deleteUser,
    checkUserExists,
    fetchUsersOnce
  } = api;

  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (usersdata.staticusers) {
      setData(usersdata.staticusers.filter(user => user.usertype === 'admin'));
    }
  }, [usersdata.staticusers]);


  if (!settings) return;

  const columns = [
    {
      field: 'firstName',
      initialEditValue: '',
      title: t('first_name'),
    },
    {
      field: 'lastName',
      initialEditValue: '',
      title: t('last_name'),
    },
    {
      field: 'email',
      editable: "onAdd",
      title: t('email'),
    },
    {
      editable: "onAdd",
      field: 'password',
      initialEditValue: '',
      title: t('password'),
    },
  ];

  return (
    <CustomMaterialTable
      data={data}
      title={'alladmin'}
      columns={columns as any}
      editable={{
        onRowAdd: newData =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              checkUserExists(newData).then((res) => {
                if (res.users && res.users.length > 0) {
                  alert(t('user_exists'));
                  reject();
                }
                else if (!(newData && newData.firstName)) {
                  alert(t('proper_input_name'));
                  reject();
                }
                if (!newData.password) {
                  alert(t('password_blank_messege'));
                  reject();
                  return;
                }
                else {
                  checkUserExists(newData).then((res) => {
                    if (res.error) {

                      console.error(res.error);
                      alert(res.error.message);
                      reject();
                    }
                    else {
                      newData['usertype'] = 'admin';
                      newData['createdAt'] = new Date().getTime();

                      mainSignUp(newData).then((res) => {
                        dispatch(fetchUsersOnce());
                        resolve("");
                      }).catch((error) => {
                        alert(error);
                        reject();
                      })
                    }
                  });
                }
              });
            }, 600);
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise((resolve, reject) => {
            setTimeout(() => {
              if (!(newData && newData.firstName)) {
                alert(t('proper_input_name'));
                reject();
              } else {
                resolve("");
                if (newData !== oldData) {
                  if (oldData && oldData.id) {
                    delete newData.tableData;
                    dispatch(editUser(oldData.id, newData));
                    dispatch(fetchUsersOnce());
                  }
                }
              }
            }, 600);
          }),
        onRowDelete: oldData =>
          settings.AllowCriticalEditsAdmin ?
            new Promise(resolve => {
              setTimeout(() => {
                resolve("");
                if (oldData.id === auth?.profile?.uid) {
                  alert(t('NOT_DELETE_YOURSELF'));
                } else {
                  dispatch(deleteUser(oldData));
                  dispatch(fetchUsersOnce());
                }
              }, 600);
            })
            :
            new Promise(resolve => {
              setTimeout(() => {
                resolve("");
                alert(t('demo_mode'));
              }, 600);
            })
        ,
      }}
    />
  );
}
